import Paper from './Paper';
export default Paper;



// WEBPACK FOOTER //
// ./src/js/Papers/index.js